import { getIsBitSet, type ListViewBitFlagsMasks } from "owa-bit-flags/lib/utils/listViewBitFlagsUtil";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { PersonaCheckboxDisplayOption } from "../store/schema/PersonaCheckboxDisplayOption";
import getPersonaCheckboxDisplay from "../store/selectors/getPersonaCheckboxDisplay";

export default function isSenderImageEnabled(): boolean {
    if (isGlobalFeatureEnabled("tri-mlCheckboxBehavior")) {
        return getPersonaCheckboxDisplay() === PersonaCheckboxDisplayOption.ShowSenderImage;
    }
    
    return !getIsBitSet(8, getGlobalSettingsAccountMailboxInfo());
}
